import { ViewContainer } from '@fortem-monorepo/react-spa'

import { Page } from '@/components/Page'
import { FLOW } from '@/constants/links'
import { MarketDataTable } from '@/pages/flow/rfq/components/MarketDataTable'
import { PricingMatrixTable } from '@/pages/flow/rfq/components/PricingMatrixTable'

export interface PricingMatrixPageProps {}

export const PricingMatrixPage: React.FC<PricingMatrixPageProps> = ({}) => {
  return (
    <Page metadata={{ title: 'Pricing Matrix' }} permissions={FLOW.PRICING_MATRIX.permissions}>
      <ViewContainer className={'flex flex-col gap-4'}>
        <PricingMatrixTable />
        <MarketDataTable options={{ sync: { enabled: false } }} />
      </ViewContainer>
    </Page>
  )
}
